export default __webpack_public_path__ + "images/models/1cdcfabe33c2dccf02dc85ff99f8c63d.usdz";